import React, { useContext } from 'react';
import { ExerciseTranslationsContext } from '../contexts/ExerciseTranslationsContext.js';
import { Button } from '../../button/index.js';
import { ProgressionBar } from '../../progression-bar/index.js';
import { getScoreAsPercentage, getMessageForPercentage } from '../util/score-utils.js';
import { ExerciseManagerContext } from '../contexts/ExerciseManagerContext.js';
import styles from './exercise-states.module.css.js';

const Container = ({ children }) => (React.createElement("div", { className: styles.overlay },
    React.createElement("div", { className: styles.wrapper },
        React.createElement("div", { className: styles.icon },
            React.createElement("i", { className: 'bc-icon bc-icon-exercise-fill', role: 'img' })),
        children)));
const Buttons = ({ onClose, onReview, onRestart, session }) => {
    const translations = useContext(ExerciseTranslationsContext);
    return (React.createElement("div", { className: styles.buttons },
        React.createElement(Button, { variant: 'secondary', onClick: onClose }, translations.exerciseResultState.buttons.close),
        onRestart && (React.createElement(Button, { variant: 'secondary', onClick: onRestart }, translations.exerciseResultState.buttons.restart)),
        onReview && session && (React.createElement(Button, { variant: 'primary', onClick: () => onReview(session) }, translations.exerciseResultState.buttons.review))));
};
const ExerciseResult = ({ result, onClose, onRestart, onReview }) => {
    const translations = useContext(ExerciseTranslationsContext);
    const percentage = getScoreAsPercentage(result.score.achieved, result.score.achievable);
    const scoreFeedbackMessage = getMessageForPercentage(percentage, translations.exerciseResultState.messages.veryGood, translations.exerciseResultState.messages.wellDone, translations.exerciseResultState.messages.bad);
    const { session } = result;
    const { showScore } = useContext(ExerciseManagerContext);
    if (showScore)
        return (React.createElement(Container, null,
            React.createElement("div", { className: styles.message },
                React.createElement("b", { className: styles.percentage },
                    percentage,
                    "%"),
                React.createElement(ProgressionBar, { maximum: result.score.maximum, achievable: result.score.achievable, achieved: result.score.achieved, translations: translations.progressionBar }),
                percentage === 100 ? (React.createElement("p", { dangerouslySetInnerHTML: { __html: translations.exerciseResultState.messages.showScore.perfectResult } })) : (React.createElement("p", { dangerouslySetInnerHTML: { __html: translations.exerciseResultState.messages.showScore.result } })),
                React.createElement(Buttons, { onClose: onClose, onRestart: onRestart, onReview: onReview, session: session }))));
    return (React.createElement(Container, null,
        React.createElement("div", { className: styles.message },
            React.createElement("h2", { className: 'heading' }, translations.exerciseResultState.title),
            React.createElement(ProgressionBar, { maximum: result.score.maximum, achievable: result.score.achievable, achieved: result.score.achieved, translations: translations.progressionBar }),
            React.createElement("p", null, scoreFeedbackMessage),
            React.createElement(Buttons, { onClose: onClose, onRestart: onRestart, onReview: onReview, session: session }))));
};

export { ExerciseResult };
